import React from 'react';
import { useLocation } from "react-router-dom";

function OptoutComplete() {
    const handleCloseWindow = () => {
      window.close();
    };

    const location = useLocation();
    const optionChoice = location.state?.optionChoice || "選択なし";
  
    return (
      <div className="submit-complete wrapper">
        <h1>{optionChoice}処理が完了しました。</h1>
        <div className="SC_h1_quit">
          <h1>ご利用ありがとうございました。</h1>
        </div>
        <div className="attention_h1">
          <h1>※システム上、{optionChoice}手続後、１週間ほどはメルマガが届く可能性がございますので、ご了承くださいませ。</h1>
        </div>
        <button className="btn_inquiry btn_quit" type="button" onClick={handleCloseWindow}>
          終了
        </button>
      </div>
    );
  }
  
export default OptoutComplete;
